import { Stack, StackProps, styled } from '@mui/material';

export const SettingsContainer = styled((props: StackProps) => (
  <Stack
    component="form"
    height="calc(100vh - 222.99px)"
    paddingX={2}
    overflow="auto"
    bgcolor="#fff"
    {...props}
  />
))({
  button: {
    textTransform: 'unset',
  },
});
